import type { RequestOptions } from '@@/plugin-request/request';
import { request as umiRequest } from '@umijs/max';
import { BizAppConfig } from 'config/application.manifest';
import { unwrapBizResponse } from './unwrapBizResponse';

type ScopedRequestOptions = RequestOptions;

export { unwrapBizResponse } from './unwrapBizResponse';

export const createRequest = (baseURL?: string) => {
  const scopedBaseURL = baseURL ?? BizAppConfig.appApiUrl ?? '';
  return async <T = unknown>(url: string, options?: ScopedRequestOptions) => {
    const body = await (
      umiRequest as unknown as <R = unknown>(
        requestUrl: string,
        requestOptions?: ScopedRequestOptions,
      ) => Promise<R>
    )(url, {
      baseURL: scopedBaseURL,
      ...(options || {}),
    });
    return unwrapBizResponse<T>(body);
  };
};

export const createAppRequest = () => createRequest(BizAppConfig.appApiUrl);
export const createTenantManagementRequest = () =>
  createRequest(BizAppConfig.appTenantManagementUrl);
